import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// This component will handle scrolling to the top of the page when the route changes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // More reliable scrolling method that handles various browser behaviors
    const scrollToTop = () => {
      // Scroll to top with smooth behavior
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      
      // Force scroll to top immediately in case the smooth scroll doesn't work
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0; // For Safari
    };
    
    // Add a small delay to ensure DOM updates complete before scrolling
    const timeoutId = setTimeout(() => {
      scrollToTop();
    }, 0);
    
    // Clean up the timeout when the component unmounts
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  // This component doesn't render anything, it just performs the scroll effect
  return null;
}

export default ScrollToTop;